import { apiRequest } from './api';
import { MensagemRapida } from '../types/atendimento';
import { ApiResponse } from '../types';

export interface RespostaRapidaCreateData {
  atalho: string;
  mensagem: string;
  mediaPath?: string | null;
  mediaType?: string | null;
  showAllUsers?: boolean;
  ativo?: boolean;
}

export interface RespostaRapidaUpdateData extends Partial<RespostaRapidaCreateData> { }

class RespostaRapidaService {
  private baseUrl = '/respostas-rapidas';

  async getAll(params?: {
    page?: number;
    limit?: number;
    search?: string;
    searchAtalhoOnly?: boolean;
    activeOnly?: boolean;
  }): Promise<ApiResponse<MensagemRapida[]>> {
    const response = await apiRequest.get<MensagemRapida[]>(this.baseUrl, { params });
    return response;
  }

  async getById(id: number): Promise<ApiResponse<MensagemRapida>> {
    const response = await apiRequest.get<MensagemRapida>(`${this.baseUrl}/${id}`);
    return response;
  }

  async create(data: RespostaRapidaCreateData): Promise<ApiResponse<MensagemRapida>> {
    const response = await apiRequest.post<MensagemRapida>(this.baseUrl, data);
    return response;
  }

  async update(id: number, data: RespostaRapidaUpdateData): Promise<ApiResponse<MensagemRapida>> {
    const response = await apiRequest.put<MensagemRapida>(`${this.baseUrl}/${id}`, data);
    return response;
  }

  async delete(id: number): Promise<ApiResponse<MensagemRapida>> {
    const response = await apiRequest.delete<MensagemRapida>(`${this.baseUrl}/${id}`);
    return response;
  }
}

export default new RespostaRapidaService();
